import { render, staticRenderFns } from "./ThirdStepHome.vue?vue&type=template&id=fa218f92&"
import script from "./ThirdStepHome.vue?vue&type=script&lang=js&"
export * from "./ThirdStepHome.vue?vue&type=script&lang=js&"
import style0 from "./ThirdStepHome.vue?vue&type=style&index=0&id=fa218f92&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports